<template>
  <section id="about-me" class="about-me-section">
    <div class="container">
      <div class="profile-header fade-in">
        <img src="@/assets/Bild_Duda.jpg" alt="Adrian Duda" class="profile-image" />
        <div class="profile-info">
          <h1>Adrian Duda</h1>
          <p class="title">Softwareentwickler aus Bielefeld, Deutschland</p>
          <p class="description">
            Als leidenschaftlicher Entwickler mit einem klaren Fokus auf moderne Webtechnologien strebe ich ständig danach, meine Fähigkeiten weiterzuentwickeln. 
            Derzeit erweitere ich meine praktischen Fähigkeiten durch selbstständige IT-Support-Dienstleistungen.<br>
          </p>
        </div>
      </div>

      <!-- Personal Data Section -->
      <div class="personal-info fade-in card">
        <h2>Persönliche Daten</h2>
        <ul>
          <li>Geboren: 21.08.1999 in Essen, NRW</li>
          <li>Familienstand: verlobt</li>
          <li>Nationalitäten: Deutsch, Polnisch</li>
        </ul>
      </div>

      <!-- Education Section -->
      <div class="education fade-in card">
        <h2>Bildung</h2>
        <ul>
          <li>
            <div class="flex-container">
              <span><strong>Ausbildung zum Fachinformatiker - Anwendungsentwicklung</strong></span>
              <span class="align-right-date">｜2023/24</span>
            </div>
            <strong>Sit&Watch Media Group GmbH</strong> <br /> Bielefeld, Nordrhein-Westfalen, Deutschland <br>
            <strong>Dietrich-Bonhoeffer-Berufskolleg</strong> <br /> Detmold, Nordrhein-Westfalen, Deutschland
          </li>
          <li>
            <div class="flex-container">
              <span><strong>Fachabitur mit Ausbildung zum Informationstechnischen Assistenten, Informatik</strong></span>
              <span class="align-right-date">｜2020/23</span>
            </div>
            Carl-Severing-Berufskolleg Bielefeld, Nordrhein-Westfalen, Deutschland
          </li>
          <li>
            <div class="flex-container">
              <span><strong>Fachoberschulreife</strong></span>
              <span class="align-right-date">｜2019/20</span>
            </div>
            Carl-Severing-Berufskolleg Bielefeld, Nordrhein-Westfalen, Deutschland
          </li>
        </ul>
      </div>

      <!-- Work Experience Section -->
      <div class="work-experience fade-in card">
        <h2>Berufserfahrung</h2>
        <ul>
          <li>
            <div class="flex-container">
              <span><strong>Ausbildung – Anwendungsentwicklung</strong></span>
              <span class="align-right-date">｜2023–24</span>
            </div>
            Sit&Watch Media Group GmbH<br />
            • Verwaltung von 100 Android Geräten<br />
            • Prozessautomatisierung (Android-Debug-Bridge Scripts)<br />
            • Geräteverwaltung (Bootstrap Vue) <br />
            • Python, Flask, RestfulAPI Schnittstellenentwicklung<br />
            • Erste Erfahrung im EPR System Odoo
          </li>
          <li>
            <div class="flex-container">
              <span><strong>Minijob – IT-Assistent/Administrator</strong></span>
              <span class="align-right-date">｜2022/23</span>
            </div>
            Sit&Watch Media Group GmbH<br />
            • Geräteverwaltung (Anforderungsanalyse)<br />
            • Standortanzeige mit Anbindung an Leaflet-API<br />
            • NGINX Routing <br />
            • Typo3 (Backend, Konfiguration)<br />
            • Google Analytics<br />
            • Mitarbeiter Support
          </li>
          <li>
            <div class="flex-container">
              <span><strong>Praktikum – Anwendungsentwicklung</strong></span>
              <span class="align-right-date">｜2022</span>
            </div>
            Sit&Watch Media Group GmbH<br />
            • Vue JS, Anbindung an interne API<br />
            • Python, Flask, RestfulAPI (Grundkenntnisse)<br />
            • Mitarbeiter Support
          </li>
        </ul>
      </div>

<!-- Skills Section -->
<div class="skills fade-in card">
  <div id="skill-header">
    <h2>Kenntnisse</h2>
    <div>
      <button @click="toggleDropdown" id="sort-btn">
        <strong>{{ criteriaSelected }} Sortieren</strong> ⬇
      </button>
      <DropdownMenu v-if="isDropdownVisible" @sort="sortSkills" />
    </div>
  </div>

  <ul>
    <li v-for="(skill, index) in sortedSkills" :key="index">
      {{ skill.name }}
      <div class="dot-rating">
        <!-- Generate filled dots -->
        <span v-for="n in skill.rating" :key="'filled-' + n" class="dot filled"></span>
        <!-- Generate unfilled dots -->
        <span v-for="n in (5 - skill.rating)" :key="'unfilled-' + n" class="dot"></span>
      </div>
    </li>
  </ul>
</div>

      <!-- Languages Section -->
      <div class="languages fade-in card">
        <h2>Sprachen</h2>
        <ul>
          <li>Deutsch: fließend
      <div class="dot-rating">
        <span class="dot filled"></span>
        <span class="dot filled"></span>
        <span class="dot filled"></span>
        <span class="dot filled"></span>
        <span class="dot filled"></span>
      </div>
    </li>
    <li>Englisch: fließend
      <div class="dot-rating">
        <span class="dot filled"></span>
        <span class="dot filled"></span>
        <span class="dot filled"></span>
        <span class="dot filled"></span>
        <span class="dot"></span>
      </div>
    </li>
    <li>Polnisch: muttersprache
      <div class="dot-rating">
        <span class="dot filled"></span>
        <span class="dot filled"></span>
        <span class="dot filled"></span>
        <span class="dot filled"></span>
        <span class="dot"></span>
      </div>
    </li>
        
        </ul>
      </div>

      <!-- Contact Section -->
      <div class="contact fade-in card">
        <h2>Kontakt</h2>
        <p>Sie können mich per E-Mail unter <a href="mailto:AdrianDudaBielefeld@gmail.com">AdrianDudaBielefeld@gmail.com</a> erreichen.</p>
        <p>Adresse: Augustastraße 2, 33649 Bielefeld</p>
        <p>Telefon: +49 176 86962324</p>
        <p>Linktr.ee: <a href="https://linktr.ee/adrian_duda" target="_blank">linktr.ee/adrian_duda</a></p>
      </div>
    </div>
  </section>
</template>

<script>
import DropdownMenu from './DropdownMenu.vue';

export default {
  components: {
    DropdownMenu,
  },
  data() {
    return {
      isDropdownVisible: false,
      skills: [
      { name: 'Vue.js', rating: 4 },
        { name: 'JavaScript', rating: 4 },
        { name: 'Bash', rating: 5 },
        { name: 'Linux (Ubuntu, RedHat, Debian)', rating: 4 },
        { name: 'ChatGPT', rating: 5 },
        { name: 'Python', rating: 3 },
        { name: 'Versionsverwaltung (Git/Github)', rating: 4 },
        { name: 'User Experience', rating: 4 },
        { name: 'Source 2 Engine', rating: 3 },
        { name: 'Node.js', rating: 3 },
        { name: 'NGINX', rating: 2 },
        { name: 'HTML', rating: 3 },
        { name: 'CSS', rating: 3 },
        { name: 'Java, OOP', rating: 2 },
        { name: 'Odoo', rating: 2 },
        { name: 'Typo3', rating: 1 },
        { name: 'Adobe Creative Cloud', rating: 2 },
        { name: 'Microsoft Office', rating: 5 },
        { name: 'Netzwerke / OSI-Modell', rating: 2 },
        { name: 'CMD', rating: 3 },
      ],
      sortedSkills: [],
      criteriaSelected: "",
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    sortSkills(criteria) {
      this.criteriaSelected = criteria;
      switch (criteria) {
        case 'Aufsteigend':
          this.sortedSkills = [...this.skills].sort((a, b) => a.rating - b.rating);
          break;
        case 'Absteigend':
          this.sortedSkills = [...this.skills].sort((a, b) => b.rating - a.rating);
          break;
        case 'Alphabetisch':
          this.sortedSkills = [...this.skills].sort((a, b) => a.name.localeCompare(b.name));
          break;
        default:
          this.sortedSkills = [...this.skills];
      }
      this.isDropdownVisible = false
      console.log(this.sortedSkills)
      console.log(this.criteriaSelected)
    },
  },
  created() {
    this.sortedSkills = [...this.skills]; // Initialize with unsorted skills
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');




#skill-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}

#sort-btn {
  color: black;
  background-color: #2e2e2e09;
  border-radius: 100px;
  padding: 0.5rem 2rem;
  cursor: pointer;
  align-self: flex-start;
  font-size: 1rem;
}



/* Dot Rating */
.languages .dot-rating,
.skills .dot-rating {
  display: flex;
  gap: 0.3rem;
}

.languages .dot, .skills .dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: transparent;
  border: white 1px solid;
}

.languages .dot.filled, .skills .dot.filled {
  background: #ffffff;
}

.about-me-section {
  padding: 4rem 10%;
  background-color: #f4f4f9;
  font-family: 'Roboto', sans-serif;
  color: #333;
  overflow: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Flex Container for Item Alignment */
.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.align-right-date {
  margin-left: auto;
  font-weight: bold;
}

/* General Styling */
.about-me-section {
  padding: 4rem 10%;
  background-color: #f4f4f9;
  font-family: 'Roboto', sans-serif;
  color: #333;
  overflow: hidden;
}


/* Profile Header */
.profile-header {
  display: flex;
  align-items: center;
  margin-bottom: 3rem;
  gap: 2rem;
  animation: slideInLeft 1s ease-out;
}

.profile-image {
  width: 350px;
  height: 350px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease-in-out;
}

.profile-image:hover {
  transform: scale(1.05);
}

.profile-info h1 {
  font-size: 3.8rem;
  color: #222;
  margin-bottom: 0.5rem;
}

.profile-info .title {
  font-size: 1.5rem;
  color: #555;
  margin-bottom: 1rem;
}

.profile-info .description {
  font-size: 1rem;
  color: #666;
  line-height: 1.7;
}

/* Section Titles */
h2 {
  font-size: 2.5rem;
  color: #222;
  margin-bottom: 1rem;
  text-transform: uppercase;
  font-weight: 600;
  position: relative;
  display: inline-block;
}

h2::after {
  content: '';
  display: block;
  width: 50px;
  height: 3px;
  background: #007bff;
  margin-top: 0.5rem;
  border-radius: 5px;
}

/* Lists */
ul {
  list-style-type: none;
  padding-left: 0;
}

ul li {
  font-size: 1.3rem;
  color: #444;
  margin-bottom: 0.75rem;
  line-height: 1.6;
  position: relative;
  padding-left: 1.5rem;
}

ul li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #007bff;
  font-size: 1.5rem;
  line-height: 1;
}

/* Skills Section */
.skills ul {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.skills ul li {
  background: #007bff;
  border: black 1px solid;
  color: #fff;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  transition: background 0.3s ease;
}

.skills ul li:hover {
  background: #0056b3;
}

.skills ul li::before {
  content: '';
}


/* Languages Section */
.languages ul li {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.languages .dot-rating {
  display: flex;
  gap: 0.3rem;
}

.languages .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ccc;
}

.languages .dot.filled {
  background: #007bff;
}

.card{
  padding: 2rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin: 1rem;
}

/* Contact Section */


.contact h2 {
  color: #222;
}

.contact p {
  font-size: 1.1rem;
  margin-bottom: 1rem;
  color: #555;
}

.contact a {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
}

.contact a:hover {
  text-decoration: underline;
}

.fade-in{
  animation: fadeIn 1.5s ease-out;
}

/* Animations */
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .profile-header {
    flex-direction: column;
    text-align: center;
  }

  .profile-image {
    width: 200px;
    height: 200px;
  }

  .profile-info h1 {
    font-size: 2.5rem;
  }

  .profile-info .title {
    font-size: 1.2rem;
  }

  h2 {
    font-size: 2rem;
  }

  ul li {
    font-size: 1.1rem;
  }
}
</style>